import { openGoogleMaps } from "@msuite/utils/misc";
import { getAddressString, getHasValidAddress, guardString } from "@msuite/utils/strings";
import type { NullableFields, Tables } from "@msuite/utils/types";

/** Props Interface */
interface AddressProps {
	item: NullableFields<Pick<Tables<"projects">, "streetName" | "houseNumber" | "zipCode" | "city">>;
}

export function Address({ item }: AddressProps) {
	/** Check if the address string is valid */
	const hasAddress = getHasValidAddress(item);

	if (!hasAddress) {
		return <p>{guardString(null)}</p>;
	}

	/** Render */
	return (
		<a
			href={openGoogleMaps(item, false)}
			className="link inline-flex flex-row gap-2 items-center"
			target="_blank"
			rel="noopener"
		>
			{getAddressString(item)}
		</a>
	);
}
